import RegisterPanelMultyEntry from './RegisterPanelMultyEntry';
export default RegisterPanelMultyEntry;
